module.exports = __webpack_public_path__ + "img/image6x1.74ce23ae.jpg";